;(function ( $, window, document, undefined ) {

  var pluginName = 'beProduct',
    defaults = {
      propertyName: "value"
    };

// The actual plugin constructor
  function Plugin( element, options ) {
    this.element = element;
    this.$element = $(element);
    this.options = $.extend( {}, defaults, options) ;
    this._defaults = defaults;
    this._name = pluginName;
    this._mxConversionRate = 20;
    this.init();
  }

  Plugin.prototype.init = function () {
    var Plugin = this;
    Plugin.setEvents();
  };

  Plugin.prototype.setEvents = function() {
    var Plugin = this;
    var inputPriceEu =  Plugin.$element.find('.beProduct-price')
    var inputPriceMx =  Plugin.$element.find('.beProduct-mx-price')


    //Settings para rellenar el campo de precio en mexico al rellenar el de Precio
    inputPriceEu.on('input', function() {
      var $priceEu = parseFloat(inputPriceEu.val());
      var $priceMx = $priceEu * Plugin._mxConversionRate;

      if (!inputPriceMx.val()) {
          inputPriceMx.trigger("focus")
          inputPriceMx.val($priceMx)
          inputPriceEu.trigger("focus")
      } else {
        inputPriceMx.val($priceMx)
      }
    });

    inputPriceEu.on('change', function() {
      var $priceEu = parseFloat(inputPriceEu.val());
      var $priceMx = $priceEu * Plugin._mxConversionRate;
      inputPriceMx.val($priceMx)
    });

    //Settings para rellenar el campo de precio al rellenar el de precio mexico

    inputPriceMx.on('input', function() {
      var $priceMx = parseFloat(inputPriceMx.val());
      var $priceEu = $priceMx / Plugin._mxConversionRate;

      if (!inputPriceEu.val()) {
       inputPriceEu.trigger("focus")
       inputPriceEu.val($priceEu)
       inputPriceMx.trigger("focus")
      } else {
       inputPriceEu.val($priceEu)
      }
    });

    inputPriceMx.on('change', function() {
      var $priceMx = parseFloat(inputPriceMx.val());
      var $priceEu = $priceMx / Plugin._mxConversionRate;
      inputPriceEu.val($priceEu)
    });

  };

  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[pluginName] = function ( options ) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName,
          new Plugin( this, options ));
      }
    });
  }

})( jQuery, window, document );